<template>
    <el-dialog class="code-verification-dialog" title="验证码校验" :visible="visible" :before-close="handleClose" width="350px" :close-on-click-modal="false">
        <el-row>
            <el-col :offset="1" :span="20">
                <el-form :model="form" :rules="rules" ref="form">
                    <div v-if="!!verificationCodeTip" class="code-verification-code-tip">{{ verificationCodeTip }}</div>
                    <el-form-item prop="mobile">
                        <el-input placeholder="手机号" v-model="form.mobile">
                            <el-button slot="append" :disabled="!form.mobile || second !== duration" @click="handleClick">{{ btnText }}</el-button>
                        </el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="10">
                            <el-form-item prop="verificationCode">
                                <el-input placeholder="验证码" v-model="form.verificationCode"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import common from '../../api/common.js';
import { phoneVerify } from '../../constant/formRegular.js';
export default {
    name: 'CodeVerifyDialog',
    components: { },
    props: {
        duration: {
            type: Number,
            default() {
                return 60;
            }
        },
        url: {
            type: String,
            default() {
                return '';
            }
        },
        visible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        defaultMobile: {
            type: String,
            default() {
                return '';
            }
        },
        userCode: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            form: {
                mobile: '',
                verificationCode: ''
            },
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: 'blur' }
                ],
                verificationCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            },
            second: this.duration,
            timeoutObj: null,
            verificationCodeTip: '',
        };
    },
    computed: {
        btnText() {
            return this.second === this.duration ? '发送验证码' : this.second + ' 秒';
        }
    },
    methods: {
        handleClick() {
            this.setTimeCircle();
            common.getVerificationCode({ userCode: this.userCode, mobile: this.form.mobile }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success(res.data || '验证码已发送!');
                    this.verificationCodeTip = res.data;
                }
            });
        },
        setTimeCircle() {
            if (this.second <= 0) {
                this.second = this.duration;
                return;
            }
            this.second = this.second - 1;
            this.timeoutObj = setTimeout(() => {
                this.setTimeCircle();
            }, 1000);
        },
        handleClose() {
            this.$emit('close');
        },
        handleConfirm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$emit('confirm', { ...this.form });
                }
            });
        },
        clear() {
            this.$refs.form.resetFields();
            clearTimeout(this.timeoutObj);
            this.second = this.duration;
            this.verificationCodeTip = '';
        }
    },
    mounted() { },
    watch: {
        visible(val) {
            if (val) {
                this.form.mobile = this.defaultMobile;
            } else {
                this.clear();
            }
        }
    }
};
</script>
<style lang="less">
    .code-verification-dialog {
        .el-form-item__content {
            line-height: 1em;
        }

        .code-verification-code-tip {
            margin-bottom: 5px;
        }

        .el-form-item {
            margin-bottom: 20px;
        }
    }
</style>